<canvas #canvasChart [style.height]="Height + 'px'" [style.min-height]="Height + 'px'"></canvas>